<template>
    <div v-if="props.token === null">
        {{ $t("Click on the button below to request a change PIN link.") }}<br>
        {{ $t("You will receive in a few minutes a link in your email inbox with the instructions to change your player PIN.") }}
        <br>

        <div class="form-group mb-0 mt-3">
            <label>{{ $t('Player') }}</label>
            <form-select v-model="requestForm.player" :options="props.players"/>
        </div>

        <div class="form-group mt-3 mb-0">
            <Button ref="requestLinkButton" @click="makeChangePinRequest" type="submit">
                {{ $t("Request change PIN link") }}
            </Button>
        </div>
    </div>
    <div v-else>
        {{ $t("Change PIN for :name", {name: props.token.player.name}) }}

        <FormInput type="password" name="pin" :label="$t('New PIN')"
                   icon="fa-solid fa-key"
                   v-model="changePinForm.pin" :error="changePinForm.errors.pin"/>

        <FormInput type="password" name="pin_confirmation"
                   v-model="changePinForm.pin_confirmation"
                   :error="changePinForm.errors.pin_confirmation"
                   icon="fa-solid fa-key"
                   :label="$t('Confirm new PIN')"/>

        <Button type="submit" ref="changePinButton" @click="changePin">
            {{ $t("Change PIN") }}
        </Button>
    </div>
</template>

<script setup>
import FormSelect from "@/Shared/FormSelect";
import Button from "@/Shared/Button";
import {ref} from "vue";
import {useForm} from "@inertiajs/inertia-vue3";
import FormInput from "@/Shared/FormInput";

store.commit("setName", "Change PIN")

const requestLinkButton = ref(null);
const changePinButton = ref(null);

const props = defineProps({
    players: Array,
    token: {
        type: Object,
        default: null
    }
})

const requestForm = useForm({
    player: null
})

const changePinForm = useForm({
    pin: null,
    pin_confirmation: null
})

function makeChangePinRequest() {
    requestLinkButton.value.toggleLoading();
    requestForm.post(route('user.change_pin.request'), {
        preserveScroll: true
    })
}

function changePin() {
    changePinButton.value.toggleLoading();
    changePinForm.post(route('user.change_pin.update', {token: props.token.token}), {
        preserveScroll: true,
        onFinish: () => changePinButton.value.toggleLoading()
    })
}
</script>
